module.exports = "https://wrf-static.prod-my.games/promo/long-lp/img/my-games-logo.e54bbd19.svg";